module.exports = __webpack_public_path__ + "img/LOCUST.3ed82cde.png";